import CustomButton from "../../components/custom/button";

export const LogoutModal = ({ modalClose }: any) => {
  const logout = () => {
    localStorage.clear();
    modalClose();
    window.location.href = "/";
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <p>{`Are you sure you want to logout?`}</p>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-md-4"></div>{" "}
        <div className="col-md-8">
          <div className="row">
            <div className="col-md-6">
              <CustomButton
                name="Cancel"
                onClick={modalClose}
                color="secondary"
                fullWidth
              />
            </div>
            <div className="col-md-6">
              <CustomButton name="Yes" onClick={logout} fullWidth />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
